import React from 'react';
import styled from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';
import CoreImage from 'gatsby-theme-core/src/components/image';

import Section from '../components/section';

const Logos = ({
  rowOptions,
  items,
  className,
}) => (
  <Section
    className={className}
    id={rowOptions?.sectionId || ''}
    backgroundColor={rowOptions?.backgroundColor}
    hideBottomSpacing={rowOptions?.hideBottomSpacing}
    hideTopSpacing={rowOptions?.hideTopSpacing}
    hideRow={rowOptions?.hideRow}
  >
    <Container small>
      <Wrapper>
        {items?.map((item) => item?.logo && (
          <div>
            <Logo
              image={item.logo}
              alt="logo"
            />
          </div>
        ))}
      </Wrapper>
    </Container>
  </Section>
);

const Logo = styled(CoreImage)`
  width: 10rem;
`;

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 2rem;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    gap: 1rem 3rem;
  }
`;

export default styled(Logos)``;
